export default{
    materiales: [],
    materialSelec: null,
}